module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Copyright © 2023 by Schiffer Publishing, Ltd.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "copyt"
  }, [_vm._v("Originally published as "), _c('i', [_vm._v("L’Atlas des zones extraterrestres")]), _vm._v(", ©2017 Flammarion, Paris")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Translated from the French by Rebecca DeWald.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Library of Congress Control Number: 2022944221")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("All rights reserved. No part of this work may be reproduced or used in any form or by any means—graphic, electronic, or mechanical, including photocopying or information storage and retrieval systems—without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("The scanning, uploading, and distribution of this book or any part thereof via the Internet or any other means without the permission of the publisher is illegal and punishable by law. Please purchase only authorized editions and do not participate in or encourage the electronic piracy of copyrighted materials.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("“Schiffer,” “Schiffer Publishing, Ltd.,” and the pen and inkwell logo are registered trademarks of Schiffer Publishing, Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Type set in Monopoly/Ailerons")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("ISBN: 978-0-7643-6593-5")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("978-1-5073-0568-3 (Epub)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed in Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published by Schiffer Publishing, Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("4880 Lower Valley Road")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Atglen, PA 19310")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Phone: (610) 593-1777; Fax: (610) 593-2002")])]), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Email: ")]), _c('a', {
    attrs: {
      "href": "mailto:Info@schifferbooks.com"
    }
  }, [_vm._v("Info@schifferbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Web: "), _c('a', {
    attrs: {
      "href": "http://www.schifferbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schifferbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("For our complete selection of fine books on this and related subjects, please visit our website at "), _c('a', {
    attrs: {
      "href": "http://www.schifferbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schifferbooks.com")]), _vm._v(". You may also write for a free catalog.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Schiffer Publishing’s titles are available at special discounts for bulk purchases for sales promotions or premiums. Special editions, including personalized covers, corporate imprints, and excerpts, can be created in large quantities for special needs. For more information, contact the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("We are always looking for people to write books on new and related subjects. If you have an idea for a book, please contact us at "), _c('a', {
    attrs: {
      "href": "mailto:proposals@schifferbooks.com"
    }
  }, [_vm._v("proposals@schifferbooks.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e47403","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_Copyright.vue
// module id = 66
// module chunks = 0